
/**
 * 模块名称: 消耗运营属性
 * @author zhuyan@372163.com
 */
import React, { useState, useEffect, useMemo, useRef } from 'react'
import api from '@/api'
import HeaderSearch from '@/components/HeaderSearch'
import Auth from '@/components/AuthMiddleware'
import {
  Table,
  Form,
  Select,
  Spin,
  DatePicker,
  Input,
  Button,
  message
} from 'antd'
import moment from 'moment'

const pageIndex = 1
const perPage = 10
let searchParam = {
  page: pageIndex,
  limit: perPage,
  adl_xiaotime_start: moment().subtract(2, 'months').startOf('month').format('YYYY-MM-DD'),
  adl_xiaotime_end: moment().format('YYYY-MM-DD'),
}
const { Option } = Select
const { RangePicker } = DatePicker

const operationalList = [
  { value: 1, label: '直销代运营' },
  { value: 2, label: '直销自运营' },
  { value: 3, label: '渠道代运营' },
  { value: 4, label: '渠道自运营' },
  { value: 5, label: '其他' },
  { value: 0, label: '空' }
]
const Operational = (props) => {
  const { match, location, history } = props
  const { getFieldDecorator, setFieldsValue, validateFields, getFieldValue, resetFields, getFieldsValue } = props.form
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(pageIndex)
  const [limit, setPageSize] = useState(perPage)
  const [total, setTotal] = useState(0)
  const [dataSource, setDataSource] = useState([])
  const [authList, setAuthList] = useState([])
  const [queryData, setQueryData] = useState({})
  const [downloadDis, setonDownloadDis] = useState(false)

  useEffect(() => {
    resetParams()
    onSelectAll()
    getList()
    api.getPageAuth().then(list => setAuthList(list))
  }, [])

  const resetParams = () => {
    searchParam = {
      page: pageIndex,
      limit: perPage,
      adl_xiaotime_start: moment().subtract(2, 'months').startOf('month').format('YYYY-MM-DD'),
      adl_xiaotime_end: moment().format('YYYY-MM-DD'),
    }
    setPageSize(perPage)
    setPage(pageIndex)
  }

  const onSelectAll = () => {
    api.getAccdetailSearchData().then(res => {
      setQueryData(res)
    })
  }

  const getList = values => {
    if (values) {
      const { page, limit } = searchParam
      searchParam = { page, limit, ...values }
    }
    let params = { ...searchParam }
    setLoading(true)
    api.getAccdetailList(params).then(data => {
      setPage(searchParam.page)
      setPageSize(searchParam.limit)
      setTotal(data.count)
      setDataSource(data.list)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const onChangeTable = (pagination, filters, sorter) => {
    searchParam.page = pagination.current
    searchParam.limit = pagination.pageSize
    getList()
  }

  const cols = [
    {
      title: '序号',
      dataIndex: 'adl_id',
      fixed: 'left',
      align: 'center',
      render: (text, record, index) => total - ((searchParam.page - 1) * searchParam.limit + index)
    },
    {
      title: '导入消耗',
      dataIndex: 'adl_consumption',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '消耗运营属性',
      dataIndex: 'adl_operational_attr',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '消耗日期',
      dataIndex: 'adl_xiaotime',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '消耗导入时间',
      dataIndex: 'adl_addtime',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '消耗关联订单',
      dataIndex: 'adl_businessno',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '订单合同编号',
      dataIndex: 'contractno',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '订单合同模板',
      dataIndex: 'templateName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '合同运营属性',
      dataIndex: 'operationalAttributes',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: 'OAID/QID',
      dataIndex: 'adl_oaid',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '客户名称/代理商名称',
      dataIndex: 'adl_oaname',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '客户类型',
      dataIndex: 'adl_customertype',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '资金所属公司',
      dataIndex: 'adl_accountid',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '项目',
      dataIndex: 'adl_oname',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '产品',
      dataIndex: 'adl_productname',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '厂商ID',
      dataIndex: 'adl_cid',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '提单人',
      dataIndex: 'userName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '收款类型',
      dataIndex: 'adl_paytype',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '运营人员',
      dataIndex: 'relServicerName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '事业群',
      dataIndex: 'groupName',
      align: 'center',
      render: (text) => text || '-'
    }
  ]

  const searchItems = useMemo(() => {
    let searchTempArr = [
      {
        label: '消耗运营属性',
        name: 'adl_operational_attr',
        component: (
          <Select placeholder='请选择消耗运营属性'
            allowClear
            showSearch
            optionFilterProp='children'
          >
            <Option value='select-all'>全部</Option>
            {
              operationalList.map((v, i) => {
                return <Option value={v.value} key={i}>{v.label}</Option>
              })
            }
          </Select>
        ),
      },
      {
        label: '消耗关联订单',
        name: 'adl_businessno',
        component: <Input placeholder='请输入消耗关联订单' />,
      },
      {
        label: '订单合同编号',
        name: 'contractno',
        component: <Input placeholder='请输入订单合同编号' />,
      },
      {
        label: 'OAID/QID',
        name: 'adl_oaid',
        component: <Input placeholder='请输入客户的OAID/QID' />,
      },
      {
        label: '厂商ID',
        name: 'adl_cid',
        component: <Input placeholder='请输入厂商ID' />,
      },
      {
        label: '资金所属公司',
        name: 'adl_accountid',
        component: (
          <Select placeholder='请选择资金所属公司'
            allowClear
            showSearch
            optionFilterProp='children'
          >
            <Option value='select-all'>全部</Option>
            {
              Object.keys(queryData?.accountList || {}).map(value => (
                <Option value={value} key={value}>{queryData?.accountList[value]}</Option>
              ))
            }
          </Select>
        ),
      },
      {
        label: '收款类型',
        name: 'adl_paytype',
        component: (
          <Select placeholder='请选择收款类型'
            allowClear
            showSearch
            optionFilterProp='children'
          >
            <Option value='select-all'>全部</Option>
            {
              Object.keys(queryData?.payTypeList || {}).map(value => (
                <Option value={value} key={value}>{queryData?.payTypeList[value]}</Option>
              ))
            }
          </Select>
        ),
      },
      {
        label: '消耗日期',
        name: 'range_SE:adl_xiaotime',

        initialValue: [
          moment().subtract(2, 'months').startOf('month'),
          moment(),
        ],
        component: (
          <RangePicker
            style={{ width: '100%' }}
            allowClear={false}
            layoutType='standard'
            onCalendarChange={(dates) => {
              const [start, end] = dates || []
              if (start && end && end.diff(start, 'days') > 365) {
                message.warning('消耗日期跨度不能超过1年,请修改！')
              }
            }}
          />
        ),
      }
    ]

    return { search: searchTempArr }
  }, [queryData])

  //导出
  const onExportFile = () => {
    setonDownloadDis(true)
    api.getHost().then(res => {
      let args = JSON.parse(JSON.stringify(searchParam))
      delete args.limit
      delete args.page
      let searchParams = new URLSearchParams()
      for (let key in args) {
        if (args[key] && args[key] !== '') {
          searchParams.set(key, args[key])
        }
      }
      searchParams.set('export', 1)
      window.location = `${res.url}/api/accDetail/detailExport?${searchParams.toString()}`
    })
    setTimeout(() => {
      setonDownloadDis(false)
    }, 5000)
  }

  return (
    <div className='vrdevice-stock-container'>
      <Spin spinning={loading} tip='Loading...'>
        <HeaderSearch
          {...searchItems}
          getList={getList}
          resetParams={resetParams}
          hasShowAll={false}
        ></HeaderSearch>

        <div className='line'></div>
        <div className='vrdevice-stock-btn'>
          <Auth auths={authList} code="export">
            <Button type="primary" icon="upload" disabled={downloadDis} onClick={onExportFile} style={{ marginLeft: 15 }}>数据导出</Button>
          </Auth>
        </div>
        <Table
          size='small'
          columns={cols}
          rowKey='adl_id'
          dataSource={dataSource}
          scroll={{ x: 'max-content' }}
          pagination={{
            defaultCurrent: pageIndex,
            pageSize: limit,
            total: total,
            showSizeChanger: true,
            showQuickJumper: true,
            current: page,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
        ></Table>
      </Spin>
    </div>
  )
}

export default Form.create()(Operational)
